import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  async copy(event) {
    event.preventDefault()
    
    await navigator.clipboard.writeText(this.textValue)
    this.showSuccess()
  }

  showSuccess() {
    const button = this.element
    const originalText = button.textContent
    
    button.textContent = "✅ Copied!"
    button.classList.add("btn-success")
    button.classList.remove("btn-outline")
    
    setTimeout(() => {
      button.textContent = originalText
      button.classList.remove("btn-success")
      button.classList.add("btn-outline")
    }, 2000)
  }
}
